import React from "react";
import { Input as AntDInput } from "antd";

const Input = ({ className, ...rest }) => {
	return <AntDInput className={`${className || ""}`} {...rest}/>
};

export default Input;
